import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useAuthStore } from '@/stores/AuthStore';

export const useLoginGuard = () => {
  const isLogin = useAuthStore((state) => state.isLogin);
  const router = useCustomRouter();

  const loginGuard = () => {
    if (!isLogin) {
      router.push(
        ROUTES.LOGIN.withSearchParams({
          searchParams: {
            redirect: window.location.pathname + window.location.search,
          },
        }),
      );

      return false;
    }

    return true;
  };

  return loginGuard;
};
